// ThemeContext.js
import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  type ReactNode,
  useMemo,
} from "react";

type ThemeContextType = {
  theme: string;
  changeTheme: (value: string) => void;
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined
);
export const ThemeProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [theme, setTheme] = useState("red-theme");

  const changeTheme = (value: string) => setTheme(value);

  const contextValue = useMemo(
    () => ({ theme, changeTheme }),
    [theme, changeTheme]
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};
